export const dailyReport = {
  dailyReport: "Daily Report",
  from: "From",
  to: "To",
  exportReport: "Export Report",
  date: "DATE",
  newUser: "NEW USER",
  activeUser: "ACTIVE USER",
  loggedInUser: "LOGGED IN USER",
  deposit: "DEPOSIT",
  withdraw: "WITHDRAW",
  adminTopup: "ADMIN TOPUP",
  depositPlayer: "DEPOSIT PLAYER",
  withdrawPlayer: "WITHDRAW PLAYER",
  totalBetRounds: "TOTAL BET ROUNDS",
  betAmount: "BET AMOUNT",
  profit: "PROFIT",
  commission: "COMMISSION",
  affiliate: "AFFILIATE",
  winLoss: "WIN/LOSS",
  winlossPercent: "WIN/LOSS %",
  loyaltyRedeemAmount: "LOYALTY REDEEM AMOUNT",
  loyaltyRedeemCount: "LOYALTY REDEEM COUNT",
  total: "Total",
  couponRedeemCount: "Coupon Redeem Count",
  couponRedeemAmount: "Coupon Redeem Amount",
};
